
import { Component, Vue, Prop } from 'vue-property-decorator'
import { UserModule } from '../../store/modules/user'
import { formatDate } from '../../utils/publish'
import DashboardBusinessDetails from './DashboardBusinessDetails.vue'
  @Component({ 
    name: 'DashboardBusinessList',
    components: { DashboardBusinessDetails } 
  })
  
export default class DashboardBusinessList extends Vue {
  @Prop() saleListData
  @Prop() total_count

  businessDetails: any = {}
  is_show_business_info: boolean = false

  mounted() {

  }
  getTime(val, type) {
    return formatDate(val, type)
  }
  closeBusiness() {
    this.is_show_business_info = false
  }
  getBusinessDetails(val) {
    this.businessDetails = val
    this.is_show_business_info = true
  }
  handleCurrentChange(val) {
    this.$emit('handle-page-change', {page: val})
  }
}
